import React from 'react';
import { HiBellAlert } from "react-icons/hi2";
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import ClickOutside from './clickOtside';
import "./popupNotification.css"
import { FaArrowRight } from 'react-icons/fa';


interface PopoverNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  notifications?: any;
  updateNotifications: () => void;
}

const PopoverNotification: React.FC<PopoverNotificationProps> = ({
  isOpen,
  onClose,
  notifications = [],
  updateNotifications,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (event: React.MouseEvent, notification: Notification) => {
    event.preventDefault();
    // navigate(`/notification/${notification.id}`);
  };

  const goToAllNotifications = () => {
    updateNotifications();
    navigate('notification');
  };

  return (
    <div>
      <ClickOutside onClickOutside={onClose}>
        {isOpen && (
          <div
            className="notification-popup rounded shadow-sm overflow-hidden"
           
          >
            <table className="w-full rounded" style={{width:"100%"}}>
              {notifications.length > 0 ? (
                <tbody style={{width:"100%"}}>
                  {notifications.map((notification:any) => (
                    <tr
                      key={notification?.id}
                      className={notification?.seen ? 'bg-gray-100' : 'bg-gray-200'}
                      onClick={(event) => handleNavigation(event, notification)}
                      style={{ cursor: 'pointer' ,width:"100%",borderBottom:"1px solid #e0e0e0"}}
                    >
                      <td className=" py-2">
                        <div className="d-flex ">
                          <div className="w-8 h-8 rounded-circle bg-orange-500
                           d-flex align-items-center justify-content-center me-3">
                            <HiBellAlert className="w-5 h-5 text-white" />
                          </div>
                          <div>
                            <p className=" font-semibold mb-1">
                            <b>{notification?.type}</b>
                            </p>
                            <p className=" mb-1">{notification?.message}</p>

                            <p className="text-muted small">
                              Created on{' '}
                              <span>{format(new Date(notification?.createdAt), 'yyyy-MM-dd \'at\' hh:mm a')}</span>
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td className="px-6 py-4 text-center">
                      <p>No Notifications</p>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            <div className="p-3 border-t">
              <button
                onClick={goToAllNotifications}
                className="btn  text-notification w-100  rounded"
              >
                <FaArrowRight size={18} className='mx-2'/>

                View All Notification
              </button>
            </div>
          </div>
        )}
      </ClickOutside>
    </div>
  );
};

export default PopoverNotification;